import { logger } from '@/shared/libs/logger';

type NavigationStep = () => void | Promise<void>;

/**
 * Runs navigations from an event handler: the first right away, each next one once the previous
 * one has landed (two back-to-back `navigate` calls can drop the first). A failed step is logged
 * rather than left as an unhandled rejection.
 */
export const navigateInOrder = (first: NavigationStep, ...rest: NavigationStep[]): void => {
  rest
    .reduce((previous, step) => previous.then(step), Promise.resolve(first()))
    .catch((error: unknown) => logger.error('App Tracker navigation failed', {}, error));
};
